import {useEffect, useState} from 'react'
import {LoginForm, LoginFormMicrosoft} from './component'
import {getIsMicrosoft} from '../services/microsoft.service'
import {getIsOnline} from '../services/login.service'
import { LoginOnline } from './component/loginOnline'

const FIVE_MINUTES = 5 * 60 * 1000 // 300000 ms
const STORAGE_KEY_LAST_FETCH = 'lastMasterFetch'
const STORAGE_KEY_STATUS = 'isMicrosoftActive'

export function Login() {
  const [isAuthenticateMicrosoft, setIsAuthenticateMicrosoft] = useState<boolean>(false)
  const [goLoginOnline, setGoLoginOnline] = useState<boolean>(false)
  const splashScreen = document.getElementById('splash-screen')

  const getIsAuthenticate = async () => {
    try {
      splashScreen.style.setProperty('display', 'flex')
      const resultMicrosoft = await getIsMicrosoft()
      const activeMicrosoft = resultMicrosoft.data.data.isActive
      localStorage.setItem(STORAGE_KEY_STATUS, JSON.stringify(activeMicrosoft))
      localStorage.setItem(STORAGE_KEY_LAST_FETCH, Date.now().toString())
      setIsAuthenticateMicrosoft(activeMicrosoft)
      const hasInternet = navigator.onLine
      const resultOnline = await getIsOnline()
      const activeOnline = resultOnline.data.data.isActive;
      if(!activeOnline && hasInternet) {
        setGoLoginOnline(true)
      }
    } catch (error) {
      console.error('Error fetching master data:', error)
    } finally {
      splashScreen.style.setProperty('display', 'none')
    }
  }

  useEffect(() => {
    const now = Date.now()
    const lastFetch = parseInt(localStorage.getItem(STORAGE_KEY_LAST_FETCH) || '0', 10)
    const savedStatus = localStorage.getItem(STORAGE_KEY_STATUS)
    if (savedStatus !== null) {
      setIsAuthenticateMicrosoft(JSON.parse(savedStatus))
    }
    getIsAuthenticate()

    const timePassed = now - lastFetch
    const initialDelay = timePassed >= FIVE_MINUTES ? 0 : FIVE_MINUTES - timePassed

    let intervalId: NodeJS.Timer
    const timeoutId = setTimeout(() => {
      getIsAuthenticate()
      intervalId = setInterval(getIsAuthenticate, FIVE_MINUTES)
    }, initialDelay)

    const handleStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY_STATUS && event.newValue !== null) {
        setIsAuthenticateMicrosoft(JSON.parse(event.newValue))
      }
    }

    window.addEventListener('storage', handleStorage)

    return () => {
      clearTimeout(timeoutId)
      if (intervalId) clearInterval(intervalId)
      window.removeEventListener('storage', handleStorage)
    }
  }, [])

  // return isAuthenticateMicrosoft ? <LoginFormMicrosoft /> : !goLoginOnline ? <LoginForm /> : <LoginOnline />
  return goLoginOnline ? <LoginOnline /> : isAuthenticateMicrosoft ? <LoginFormMicrosoft /> : <LoginForm />
}
